import React from 'react';
import { Stack, TextField, FormControl, Select, MenuItem, Typography } from '@mui/material';
import { TimerOutlined } from '@mui/icons-material';

const TIMEOUT_UNITS = ['Minutes', 'Hours', 'Days'] as const;

interface ApprovalTimeoutPickerProps {
  duration: number;
  unit: string;
  onDurationChange: (duration: number) => void;
  onUnitChange: (unit: string) => void;
}

export const ApprovalTimeoutPicker: React.FC<ApprovalTimeoutPickerProps> = ({
  duration,
  unit,
  onDurationChange,
  onUnitChange,
}) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <TimerOutlined sx={{ color: '#64748b', fontSize: 18 }} />
    <Typography variant="body2" sx={{ fontWeight: 500, color: '#1e293b', whiteSpace: 'nowrap' }}>
      Timeout:
    </Typography>
    <TextField
      size="small"
      type="number"
      value={duration}
      onChange={(e) => onDurationChange(Math.max(0, Number(e.target.value)))}
      inputProps={{ min: 0 }}
      sx={{ width: 100 }}
    />
    <FormControl size="small" sx={{ minWidth: 110 }}>
      <Select value={unit} onChange={(e) => onUnitChange(e.target.value)}>
        {TIMEOUT_UNITS.map((u) => (
          <MenuItem key={u} value={u}>{u}</MenuItem>
        ))}
      </Select>
    </FormControl>
    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
      (0 = no timeout)
    </Typography>
  </Stack>
);
